import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from '../../../../constants/layout/store/filterSlice';

const DisposedOfAssetReport = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(updateNavbarHeading("Disposed off Asset"))
    }, [])
    const [searchTerm, setSearchTerm] = useState("");
    const [disposedAssetListData, setDisposedAssetListData] = useState([]);
    const [assetTypeOption, setAssetTypeOption] = useState([])
    const [categoryTypeOption, setCategoryTypeOption] = useState([])
    const [loading, setLoading] = useState(true);

    const columns = {
        name: { text: " Name", align: "left", visible: true },
        Description: { text: "Description", align: "start", visible: true },
        AssetTypes: { text: "Type", align: "start", visible: true },
        CategoryName: { text: "Category", align: "start", visible: true },
        Brand: { text: "Make", align: "start", visible: true },
        Model: { text: "Model", align: "start", visible: true },
        InvoiceNumber: { text: "Invoice No.", align: "end", visible: true },
        VendorName: { text: "Vendor", align: "left", visible: true },
        AssetPrice: { text: "Price", align: "end", visible: true },

    };

    useEffect(() => {
        fetchGetDisposedReportList();
    }, []);
    const [apiStatus, SetApiStatus] = useState('');

    const fetchGetDisposedReportList = async () => {
        SetApiStatus(undefined)

        try {
            const response = await GetServiceCaller(`${API_URL}support-desk-reports/1?P_AssetType=&P_CategoryID_1160=`);
            SetApiStatus(response?.status);

setDisposedAssetListData([])

            if (response.status === 200) {
                const cleanedData = response?.data?.data;

                setDisposedAssetListData(cleanedData?.map(o => ({
                    ...o, AssetPrice: Number(o.AssetPrice).toFixed(2)
                })));

                const assetType = Object.entries(response?.data?.AssetType || {}).map(([key, value]) => ({
                    value: parseInt(key, 10), // Convert key to a number
                    label: value,
                }));
                setAssetTypeOption(assetType)


                setLoading(false);
            } else {
                console.error(
                    "Failed to fetch Disposed Report. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching Disposed Report", error);
        }
    };


    const [filterFormData, setFilterData] = useState([]);
    useEffect(() => {
        const assetType = filterFormData.find((o) => o.label === "Asset Type")?.value;

        // Explicitly check for `undefined` or `null` instead of falsy values like 0
        if (assetType !== undefined && assetType !== null) {
            fetchGetCategoryDetails(assetType);
            setCategoryTypeOption([]); // Clear category options while fetching new data
        }
    }, [filterFormData]);

    const fetchGetCategoryDetails = async (id) => {
        try {
            const queryParams = new URLSearchParams({
                AssetType: id,
            });
            const response = await GetServiceCaller(`${API_URL}get-asset-categories?${queryParams.toString()}`);



            if (response.status === 200) {
                const fetchData = response?.data?.data;
                const categoryList = fetchData?.map((ele, index) => ({
                    value: ele?.ID,
                    label: ele?.CategoryName
                }))


                setCategoryTypeOption(categoryList)

                setLoading(false);
            } else {
                console.error(
                    "Failed to fetch model masters. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("An error occurred while fetching brand details:", error);
        }
    };

    const formDatas = [
        {
            name: "Asset Type",
            type: "Select",
            options: [...assetTypeOption],
        },
        {
            name: "Category",
            type: "Select",
            options: [...categoryTypeOption || []],
        },
    ];


    const handleFilterChange = (e, name) => {
        setFilterData((prevFormData) => {
            // Check if the label already exists
            const existingLabelIndex = prevFormData.findIndex(
                (item) => item.label === name
            );

            // If the label exists, update its value
            if (existingLabelIndex !== -1) {
                const updatedFormData = prevFormData.map((item, index) =>
                    index === existingLabelIndex
                        ? { ...item, value: e.value !== undefined ? e.value : e }
                        : item
                );
                return updatedFormData;
            } else {
                // If the label doesn't exist, add a new label-value pair
                return [
                    ...prevFormData,
                    {
                        label: name,
                        value: e.value !== undefined ? e.value : e, // Assuming e is an event object
                    },
                ];
            }
        });
    };
    const handleGetData = async () => {
        SetApiStatus(undefined)
setDisposedAssetListData([])
        try {
            const response = await GetServiceCaller(
                `${API_URL}support-desk-reports/1?P_AssetType=${filterFormData.find((o) => o.label === "Asset Type")
                    ? filterFormData.find((o) => o.label === "Asset Type").value
                    : 0
                }&P_CategoryID_1160=${filterFormData.find((o) => o.label === "Category")
                    ? filterFormData.find((o) => o.label === "Category").value
                    : 0
                }`
            );
            SetApiStatus(response?.status)
            if (response.status === 200) {
                const cleanedData = response?.data?.data;
                setDisposedAssetListData(cleanedData);
                setLoading(false);
            } else {
                console.error(
                    "Failed to fetch Disposed Report. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching Disposed Report:", error);
        }
    };

    const handleReset = () => {
        setFilterData([])
        fetchGetDisposedReportList()
    }
    return (
        <>
            <div className="container-fluid" id="skill_section">
                <div className="container-fluid" id="skill-table-area">
                    <div className="row">
                        <Dynamic_PR_table
                            data={disposedAssetListData}
                            columns={columns}
                            itemsPerPage={10}
                            handleReset={handleReset}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            isApiStatus={apiStatus}
                            isRequiredStatus={true}
                            showIcon1={true}
                            isSorting={true}
                            showIcon2={false}
                            formDatas={formDatas}
                            filterFormData={filterFormData}
                            handleGetData={handleGetData}
                            isFilterRequired={true}
                            isActionRequired={false}
                            isAddNewBtnRequired={false}
                            showIcon3={false}
                            showIcon4={false}
                            showIcon5={false}
                            handleChange={handleFilterChange}
                            // handleIcon1={handleEdit}
                            // handleAddNew={handleAddNewVendor}
                            add
                            more
                            function
                            icons={{
                                Icon1: <i class="bi bi-pencil-square icons"></i>,
                                Icon1Text: " Edit",
                                Icon2: <i class="bi bi-trash-fill icons"></i>,
                                Icon3: <i class="bi bi-eye-fill icons"></i>,
                                Icon4: <i class="bi bi-plus-square icons"></i>,
                                Icon4Text: " Add Sub-Contractor",
                            }}
                        />
                    </div>
                </div>

            </div>

        </>
    )
}

export default DisposedOfAssetReport